import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const features = [
  {
    title: "Multi-Channel Collection",
    description:
      "With Zola’s NFC technology, customers can give feedback with a simple tap of their phone.",
    image:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50cb972e936f2b66b2acd_Frame%201618869445.png",
  },
  {
    title: "Real-Time Analytics",
    description:
      "Track sentiment, monitor trends, and gain actionable insights instantly. No more waiting for data.",
    image:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50cb972e936f2b66b2ad1_Frame%201618869446.png",
  },
  {
    title: "Customizable Surveys",
    description:
      "Create tailored surveys for your business. Ask key questions to gather essential insights.",
    image:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50cb972e936f2b66b2acf_Frame%201618869447.png",
  },
  {
    title: "Seamless Integration",
    description:
      "Zola integrates effortlessly with your current tools and processes, making feedback collection second nature.",
    image:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50cb972e936f2b66b2ad7_Frame%201618869445%20(1).png",
  },
  {
    title: "Automated Reports",
    description:
      "Get actionable reports delivered to you, helping track customer sentiment and areas for improvement.",
    image:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50cb972e936f2b66b2ad3_Frame%201618869445%20(2).png",
  },
  {
    title: "Coupons",
    description:
      "You can create exclusive coupons to encourage repeat business and enhance customer loyalty.",
    image:
      "https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50cb972e936f2b66b2ad5_Frame%201618869447%20(1).png",
  },
];

const FeaturesGrid = () => {
  return (
    <section className="w-full bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {features.map((feature, index) => {
            const { ref, inView } = useInView({
              triggerOnce: true,
              threshold: 0.2,
            });

            return (
              <motion.div
                key={index}
                ref={ref}
                initial={{ opacity: 0, y: 30 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{
                  duration: 0.6,
                  ease: "easeOut",
                  delay: index * 0.1,
                }}
                className="flex flex-col items-center text-center"
              >
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full max-w-[300px] h-auto mb-6 object-contain"
                />
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 text-base max-w-sm">
                  {feature.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesGrid;
